module.exports = __webpack_public_path__ + "static/makinde-a21736889ba72e5e84c7890f5bd82f66.jpg";